export default __webpack_public_path__ + "static/media/yucatan.f5e9f728.png";